import { useEffect, useRef, useState } from "react";
import { ArrowLeft, MessageSquare, Search } from "lucide-react";
import { api } from "@/lib/api";
import { ago, fmtTs } from "@/components/sms/smsUtils";

const Thread = ({ conv, tick, onBack }) => {
  const [rows, setRows] = useState([]);
  const end = useRef(null);
  useEffect(() => {
    if (!conv) return;
    api.get(`/sms/conversations/${conv.id}/messages`).then(({ data }) => setRows(data.rows)).catch(() => {});
  }, [conv, tick]);
  useEffect(() => { end.current?.scrollIntoView({ block: "end" }); }, [rows.length]);
  if (!conv) return <div className="h-full grid place-items-center text-sm text-[#9A9A90]">Left se koi chat chuno</div>;
  return (
    <div className="flex flex-col h-full" data-testid="sms-thread">
      <div className="px-4 py-3 border-b border-[#E0DFD6] font-semibold flex items-center gap-2">
        <button onClick={onBack} className="md:hidden p-1 -ml-1 rounded hover:bg-[#EFEEE6]" data-testid="sms-thread-back" aria-label="Back"><ArrowLeft className="w-4 h-4" /></button>
        {conv.name || conv.number}
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-2 bg-[#FAFAF6]">
        {rows.map((m) => (
          <div key={m.id} className={`max-w-[80%] rounded-2xl px-3 py-2 text-sm ${m.incoming ? "bg-white border border-[#E0DFD6]" : "ml-auto bg-[#385C4B] text-white"}`} data-testid={`sms-msg-${m.id}`}>
            <div className="whitespace-pre-wrap break-words">{m.text || <i className="opacity-60">(media)</i>}</div>
            <div className={`text-[10px] mt-1 ${m.incoming ? "text-[#9A9A90]" : "text-white/70"}`}>
              {fmtTs(m.ts)}{m.source === "phone_app" && " · Phone"}{m.codes.length > 0 && " · code saved"}
            </div>
          </div>
        ))}
        {!rows.length && <div className="text-center text-xs text-[#9A9A90] py-8">Messages load ho rahe hain… Sync Now se purane messages aa jayenge.</div>}
        <div ref={end} />
      </div>
    </div>
  );
};

export const MessagesTab = ({ tick }) => {
  const [q, setQ] = useState("");
  const [convs, setConvs] = useState([]);
  const [sel, setSel] = useState(null);
  useEffect(() => {
    api.get("/sms/conversations", { params: { q, limit: 100 } }).then(({ data }) => setConvs(data.rows)).catch(() => {});
  }, [q, tick]);
  return (
    <div className="bg-white border border-[#E0DFD6] rounded-xl grid md:grid-cols-[340px_1fr] h-[70vh] overflow-hidden" data-testid="sms-messages-tab">
      <div className={`${sel ? "hidden md:flex" : "flex"} border-r border-[#E0DFD6] flex-col min-h-0`}>
        <label className="relative m-3">
          <Search className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-[#9A9A90]" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search number or text"
            className="h-9 pl-8 pr-3 w-full rounded-full border border-[#E0DFD6] text-sm focus:outline-none focus:ring-2 focus:ring-[#385C4B]/30" data-testid="sms-conv-search" />
        </label>
        <div className="flex-1 overflow-y-auto">
          {convs.map((c) => (
            <button key={c.id} onClick={() => setSel(c)} data-testid={`sms-conv-${c.id}`}
              className={`w-full text-left px-4 py-3 border-b border-[#F0EFE8] flex gap-3 transition-colors ${sel?.id === c.id ? "bg-[#EFEEE6]" : "hover:bg-[#FAFAF6]"}`}>
              <span className="w-9 h-9 rounded-full bg-[#385C4B]/10 text-[#385C4B] grid place-items-center shrink-0"><MessageSquare className="w-4 h-4" /></span>
              <span className="min-w-0 flex-1">
                <span className="flex justify-between gap-2">
                  <span className={`truncate text-sm ${c.unread ? "font-bold" : "font-medium"}`}>{c.name || c.number}</span>
                  <span className="text-[10px] text-[#9A9A90] whitespace-nowrap">{ago(c.last_ts)}</span>
                </span>
                <span className="block truncate text-xs text-[#6B6B61] font-mono">{c.last_text}</span>
              </span>
            </button>
          ))}
          {!convs.length && <div className="p-6 text-center text-xs text-[#9A9A90]" data-testid="sms-conv-empty">Phone connect hone ke baad chats yahan dikhengi.</div>}
        </div>
      </div>
      <div className={`${sel ? "block" : "hidden md:block"} min-h-0`}><Thread conv={sel} tick={tick} onBack={() => setSel(null)} /></div>
    </div>
  );
};
